import axios from 'axios';

const SUBLET_INVOICE_PATH = '/api/sublet-invoices';
const SEARCH_PATH = '/search';
const LOOKUPS_PATH = '/lookups';
const SAVE_PATH = '/save';
const UPDATE_SERVICE_ORDER_PATH = '/update-service-order';
const COMPLETE_PATH = '/complete';
const SEND_PATH = '/send';
const VALIDATE_PATH = '/validate';
const DOWNLOAD_PATH = '/download';
const INVOICES_COUNT_PATH = '/sublet-invoices-count';
const HISTORY_ENDING = 'history';
const SUBLET_INVOICE_PATH_ENDING = 'attachments';
const PURCHASE_ORDER_PATH = '/pos';

class SubletInvoiceService {
  async submitInvoice({ serviceOrderId, billToCustomerId, jobId, description, unitId, files }) {
    const url = `${SUBLET_INVOICE_PATH}/${serviceOrderId}/${billToCustomerId}/${jobId}/${description}/${unitId}/${SUBLET_INVOICE_PATH_ENDING}`;
    let formData = new FormData();
    formData.append('files', files);
    const result = await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return result;
  }
  async fetchSubletInvoiceLookups() {
    const url = `${SUBLET_INVOICE_PATH}${LOOKUPS_PATH}`;
    const lookups = await axios.get(url);
    return lookups;
  }
  async searchSubletInvoices(parameters) {
    const url = `${SUBLET_INVOICE_PATH}${SEARCH_PATH}/${encodeURIComponent(parameters.category)}`;
    const invoices = await axios.get(url, {
      params: parameters
    });
    return invoices;
  }
  async fetchSubletInvoice(parameters) {
    const url = `${SUBLET_INVOICE_PATH}/${encodeURIComponent(parameters.docId)}`;
    const invoice = await axios.get(url);
    return invoice;
  }
  async fetchSubletInvoiceHistory(parameters) {
    const url = `${SUBLET_INVOICE_PATH}/${encodeURIComponent(parameters.serviceOrderId)}/${HISTORY_ENDING}`;
    const invoice = await axios.get(url);
    return invoice;
  }
  async saveSubletInvoice(parameters) {
    const url = `${SUBLET_INVOICE_PATH}${SAVE_PATH}`;
    await axios.put(url, parameters);
  }
  async updateServiceOrderFromSubletInvoice(parameters) {
    const url = `${SUBLET_INVOICE_PATH}${UPDATE_SERVICE_ORDER_PATH}`;
    await axios.put(url, parameters);
  }
  async validateSubletInvoice(parameters) {
    const url = `${SUBLET_INVOICE_PATH}${VALIDATE_PATH}`;
    await axios.put(url, parameters);
  }
  async completeSubletInvoice(parameters) {
    const url = `${SUBLET_INVOICE_PATH}${COMPLETE_PATH}`;
    await axios.put(url, parameters);
  }
  async sendSubletInvoice(parameters) {
    const url = `${SUBLET_INVOICE_PATH}${SEND_PATH}`;
    await axios.put(url, parameters);
  }
  async validateHeaderSubletInvoice(parameters) {
    const url = `${SUBLET_INVOICE_PATH}${VALIDATE_PATH}/header`;
    await axios.put(url, parameters);
  }
  async fetchDownload(parameters) {
    const url = `${SUBLET_INVOICE_PATH}${DOWNLOAD_PATH}/${encodeURIComponent(parameters.filename)}`;
    return await axios.get(url, {
      responseType: 'blob'
    });
  }
  async fetchHistoryDownload(parameters) {
    const url = `${SUBLET_INVOICE_PATH}${DOWNLOAD_PATH}/${encodeURIComponent(parameters.filename)}/${HISTORY_ENDING}`;
    return await axios.get(url, {
      responseType: 'blob'
    });
  }
  async getSubletInvoicesCount(parameters) {
    const url = `${SUBLET_INVOICE_PATH}${INVOICES_COUNT_PATH}/${encodeURIComponent(parameters)}`;
    const invoicesCount = await axios.get(url);
    return invoicesCount;
  }
  async fetchSubletInvoicePos(parameters) {
    const url = `${SUBLET_INVOICE_PATH}${SEARCH_PATH}${PURCHASE_ORDER_PATH}/${encodeURIComponent(parameters.brnId)}`;
    const POs = await axios.get(url);
    return POs;
  }
}

export default new SubletInvoiceService(); // singleton object
